/**
 * Thin wrapper around the GTM data layer. Everything the site tracks goes
 * through here so the payload shape stays consistent with what the server
 * renders (see SMD.Accelerator.Extensions/Tracking/DataLayer.cs).
 */

const getDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
};

/**
 * Pushes a raw payload. Use pushEvent/pushEcommerceEvent unless you need
 * something that is not an event, for example a context object.
 */
export const push = (payload) => {
    if (!payload) {
        return;
    }
    getDataLayer().push(payload);
};

/**
 * Pushes a plain (non ecommerce) event, for example search or form_submit.
 */
export const pushEvent = (event, params = {}) => {
    if (!event) {
        return;
    }
    push({ event, ...params });
};

/**
 * Pushes a GA4 ecommerce event. The previous ecommerce object is cleared
 * first, as Google recommends, so values do not leak between events.
 */
export const pushEcommerceEvent = (event, ecommerce) => {
    if (!event || !ecommerce) {
        return;
    }
    push({ ecommerce: null });
    push({ event, ecommerce });
};

/**
 * Rounds a monetary value to two decimals and returns undefined for values
 * that are not numbers, so they are left out of the payload entirely.
 */
export const money = (value) => {
    const parsed = typeof value === 'string' ? parseFloat(value) : value;
    if (typeof parsed !== 'number' || isNaN(parsed)) {
        return undefined;
    }
    return Math.round(parsed * 100) / 100;
};
